import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import { useState } from "react";
import { api, BRAND } from "../../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome! You're on the list.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe right now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative mt-24 border-t border-white/10 bg-[#00007A]">
      <div className="container-narrow py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logoChurch} alt="logo" className="h-14 w-14 rounded-full ring-1 ring-[#D4AF37]/40" />
            <div>
              <div className="font-serif text-xl tracking-wide">Abundant Life <span className="gold-text">II</span></div>
              <div className="text-[11px] tracking-[0.3em] text-white/80 uppercase">The Surrender Church</div>
            </div>
          </div>
          <p className="mt-5 text-white/80 max-w-md leading-relaxed">
            An online-first ministry led by {BRAND.pastor}. Where surrender meets transformation —
            healing, growth, and Kingdom purpose for a generation hungry for clarity.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2">
            <input
              data-testid="footer-newsletter-input"
              type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              placeholder="Your email — Spirit-led notes" className="input-luxe"
            />
            <button data-testid="footer-newsletter-submit" disabled={busy} className="btn-gold !px-5">
              {busy ? "..." : "Join"}
            </button>
          </form>
        </div>

        <div className="md:col-span-3">
          <div className="label-luxe">Explore</div>
          <ul className="mt-4 space-y-2 text-white/90">
            <li><Link to="/" className="hover:text-[#D4AF37]">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#D4AF37]">About Pastor Shalonda</Link></li>
            <li><Link to="/services" className="hover:text-[#D4AF37]">Services & Prayer Wall</Link></li>
            <li><Link to="/booking" className="hover:text-[#D4AF37]">Book Pastor</Link></li>
            <li><Link to="/blueprint" className="hover:text-[#D4AF37]">Next Step Blueprint</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="label-luxe">Connect</div>
          <ul className="mt-4 space-y-3 text-white/90 text-sm">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> {BRAND.city}</li>
            <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#D4AF37]" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-[#D4AF37] break-all">{BRAND.email}</a></li>
            <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#D4AF37]" />
              <a href={`tel:${BRAND.phone.replace(/\D/g,"")}`} className="hover:text-[#D4AF37]">{BRAND.phone}</a></li>
          </ul>
          <div className="mt-5 flex gap-3">
            <a href={BRAND.youtube} target="_blank" rel="noreferrer" data-testid="footer-youtube"
               className="p-2.5 rounded-full border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white/90"><Youtube className="w-4 h-4" /></a>
            <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram"
               className="p-2.5 rounded-full border border-white/10 hover:border-[#D91668] hover:text-[#D91668] text-white/90"><Instagram className="w-4 h-4" /></a>
            <a href={BRAND.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook"
               className="p-2.5 rounded-full border border-white/10 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white/90"><Facebook className="w-4 h-4" /></a>
            <a href={BRAND.tiktok} target="_blank" rel="noreferrer" data-testid="footer-tiktok"
               className="p-2.5 rounded-full border border-white/10 hover:border-[#D91668] hover:text-[#D91668] text-white/90 text-xs font-bold flex items-center justify-center w-9 h-9">TT</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-narrow py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Abundant Life No. 2 — The Surrender Church. All rights reserved.</div>
          <div className="font-accent tracking-[0.3em] uppercase text-[#D4AF37]/70">Healing · Growth · Purpose</div>
        </div>
      </div>
    </footer>
  );
}
